module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content",
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('div', [_c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('a', {
    staticClass: "button button-link button-nav pull-left",
    on: {
      "click": function($event) {
        return _vm.gotolast()
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-left"
  }), _vm._v("返回\n      ")])])]), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "10px",
      "margin-top": "2.5rem"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    },
    attrs: {
      "src": _vm.baseurl + _vm.pro.imageUrl
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('merchdata', {
    attrs: {
      "merchList": _vm.merchandise,
      "description": _vm.$route.query.des,
      "proo": _vm.$route.params.pro
    }
  }), _vm._v(" "), (_vm.merchandise.length > 10) ? _c('div', {
    staticClass: "button",
    staticStyle: {
      "margin-bottom": "5rem"
    },
    on: {
      "click": _vm.loadmore
    }
  }, [_vm._v("更多...")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "over"
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div'), _vm._v(" "), _c('div', {
    staticClass: "search-input",
    staticStyle: {
      "margin-left": "0.5rem",
      "margin-right": "0.5rem",
      "margin-top": "0.5rem"
    }
  }, [_c('label', {
    staticClass: "icon icon-search",
    attrs: {
      "for": "search"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "open-popup open-goods",
    attrs: {
      "type": "search",
      "id": "search",
      "data-popup": ".popup-goods",
      "placeholder": "输入商品...",
      "readonly": "",
      "unselectable": "on"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6111aab7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Channels/ChannelDetails.vue
// module id = 1658
// module chunks = 8